/* WME v3 — dynamic delivery dates. Generic site-wide promise = BEST CASE 24h (tomorrow);
   per-tier [data-wme-arrive] elements keep their own 24/48/72h dates. No after-5pm pushback. */
(function () {
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function dateAfter(hours) { return new Date(Date.now() + hours * 3600 * 1000); }
  var dates = { h24: fmt(dateAfter(24)), h48: fmt(dateAfter(48)), h72: fmt(dateAfter(72)) };
  window.wmeDates = dates;

  var BEST = 'by tomorrow, ' + dates.h24;
  var PATTERNS = [
    [/within\s+24\s*[–—-]\s*48\s*(hours|hrs|hour)/gi, BEST],
    [/\bin\s+24\s*[–—-]\s*48\s*(hours|hrs|hour)/gi, BEST],
    [/\b24\s*[–—-]\s*48\s*(hours|hrs|hour)/gi, BEST],
    [/within\s+1\s*[–—-]\s*2\s*days/gi, BEST],
    [/\b1\s*[–—-]\s*2\s*days/gi, BEST],
    [/Estimated Delivery:\s*2\s*Days/gi, 'Arrives as soon as ' + dates.h24]
  ];
  function fix(root) {
    try {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        var p = n.parentNode;
        if (!p) continue;
        var tag = p.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') continue;
        var t = n.nodeValue;
        if (!t || t.length < 4) continue;
        var changed = false;
        for (var i = 0; i < PATTERNS.length; i++) {
          if (PATTERNS[i][0].test(t)) { t = t.replace(PATTERNS[i][0], PATTERNS[i][1]); changed = true; }
          PATTERNS[i][0].lastIndex = 0;
        }
        if (changed) n.nodeValue = t;
      }
    } catch (e) {}
  }
  function arriveEls() {
    var els = document.querySelectorAll('[data-wme-arrive]');
    for (var i = 0; i < els.length; i++) {
      var h = els[i].getAttribute('data-wme-arrive');
      var d = h === '24' ? dates.h24 : (h === '72' ? dates.h72 : dates.h48);
      els[i].textContent = 'Arrives by ' + d;
    }
  }
  function run() { fix(document.body); arriveEls(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var ticks = 0;
  var poll = setInterval(function () { run(); if (++ticks >= 8) clearInterval(poll); }, 1000);
})();
